import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { HeaderButton, HeaderText } from '../../auth.styles';
import { HeaderWrapper } from './SignInHeader.styles';

const SignInHeader = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <HeaderWrapper>
      <HeaderText>{t('auth.signUp.haveAccount')}</HeaderText>
      <HeaderButton onClick={() => navigate('/login')}>{t('auth.common.signIn')}</HeaderButton>
    </HeaderWrapper>
  );
};

export default SignInHeader;
